export default function isSafari() {
	const hasSafari = window.navigator.userAgent.toLowerCase().indexOf('safari') > -1;
	const hasChrome = window.navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

	return hasSafari && !hasChrome;
}
